import React from "react";
import { Container, Typography, Box, Grid, Card, CardContent, Button, CardActions } from "@mui/material";
import { VpnKey, Storage, ArrowForward, Login } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const Home: React.FC = () => {
  const { isAuthenticated } = useAuth();
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom color="primary" sx={{ typography: { xs: "h5", sm: "h4" } }}>
          Gerenciador de Senhas Seguro
        </Typography>
        <Typography variant="body1" component="p" color="text.secondary" sx={{ mb: 4, typography: { xs: "body2", sm: "body1" } }}>
          Gere senhas fortes e armazene-as com segurança. Suas senhas são criptografadas e protegidas.
        </Typography>

        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
              <CardContent sx={{ flexGrow: 1, textAlign: "center" }}>
                <VpnKey sx={{ fontSize: 60, color: "primary.main", mb: 2 }} />
                <Typography variant="h5" component="h3" gutterBottom>
                  Gerar Senhas
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Crie senhas fortes e personalizadas com critérios customizáveis
                </Typography>
              </CardContent>
              <CardActions sx={{ justifyContent: "center", pb: 2 }}>
                <Button variant="contained" component={Link} to="/generator" endIcon={<ArrowForward />} size="large">
                  Gerar Agora
                </Button>
              </CardActions>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
              <CardContent sx={{ flexGrow: 1, textAlign: "center" }}>
                <Storage sx={{ fontSize: 60, color: "secondary.main", mb: 2 }} />
                <Typography variant="h5" component="h3" gutterBottom>
                  Armazenar Senhas
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Salve e organize suas senhas com segurança em grupos
                </Typography>
              </CardContent>
              <CardActions sx={{ justifyContent: "center", pb: 2 }}>
                {isAuthenticated ? (
                  <Button variant="contained" color="secondary" component={Link} to="/dashboard" endIcon={<ArrowForward />} size="large">
                    Meu Dashboard
                  </Button>
                ) : (
                  <Button variant="contained" color="secondary" component={Link} to="/login" endIcon={<Login />} size="large">
                    Fazer Login
                  </Button>
                )}
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};
export default Home;
